import { render, staticRenderFns } from "./UserCombo.vue?vue&type=template&id=44b3c848&scoped=true"
import script from "./UserCombo.vue?vue&type=script&lang=js"
export * from "./UserCombo.vue?vue&type=script&lang=js"
import style0 from "./UserCombo.vue?vue&type=style&index=0&id=44b3c848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b3c848",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemContent,VListItemTitle})
